import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import { videoDataRequest } from "../../../modules/students-modules/videos/Actions";
import "./style.css";

/**
 * Tracks playback via VdoCipher player API (`getPlayer()` on `<vdocipher-player />`).
 */
export default function VideoStatusUsingAPI({ videoRef, isAPIReady, videoId }) {
    const [status, setStatus] = useState("NA");
    const [player, setPlayer] = useState(null);
    const [currentTime, setCurrentTime] = useState(0);
    const [searchParams] = useSearchParams();
    const params = useParams();

    const resolvedVideoId =
        videoId ??
        params.id ??
        params.video_id ??
        searchParams.get("video") ??
        null;

    const [totalPalyed, setTotalPlayed] = useState(null);
    const [totalCoverd, setTotalCoverd] = useState(null);

    const userData = useSelector((state) => state.user.userData);
    const videoData = useSelector((state) => state.chapterVideos.videoData);
    const dispatch = useDispatch();

    const [start, setStart] = useState(0);

    useEffect(() => {
        if (!isAPIReady) return;

        if (!videoRef || typeof videoRef.getPlayer !== "function") {
            setPlayer(null);
            return;
        }

        let cancelled = false;

        videoRef.getPlayer().then((playerInstance) => {
            if (cancelled || !playerInstance?.video) return;
            setPlayer(playerInstance);
            playerInstance.video.addEventListener("play", () =>
                setStatus("Playing")
            );
            playerInstance.video.addEventListener("pause", () =>
                setStatus("pause")
            );
            playerInstance.video.addEventListener("canplay", () =>
                setStatus("Ready")
            );
            playerInstance.video.addEventListener("timeupdate", () => {
                setCurrentTime(playerInstance.video.currentTime);
            });
        });

        return () => {
            cancelled = true;
            setPlayer(null);
        };
    }, [isAPIReady, videoRef]);

    useEffect(() => {
        if (player) {
            player.api.getTotalPlayed().then((data) => {
                let diff = data - start;
                setStart(data);
                setTotalPlayed(diff);
            });

            setTotalCoverd(player.video.currentTime);
        }
    }, [player, status]);

    useEffect(() => {
        if (!(totalPalyed && totalCoverd && resolvedVideoId)) return;

        dispatch(
            videoDataRequest({
                total_played: totalPalyed,
                total_covered: totalCoverd,
                video_id: resolvedVideoId,
                user_id: userData?.id,
            })
        );
    }, [totalCoverd, totalPalyed, resolvedVideoId, dispatch, userData?.id]);

    useEffect(() => {
        if (videoData?.views_count > 3) {
            window.location.reload();
        }
    }, [videoData]);

    return <></>;
}
